
import Vue, { watch } from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ProductDocIcon from "./ProductDocIcon.vue";
import { Message } from 'element-ui';

@Component({ components: { ProductDocIcon } })
export default class ProductDoc extends Vue {
    @Prop() productDocVisible: boolean;
    @Prop() productDoc: any;

    @Getter businessDocTypes: any;
    @Getter businessUrl: any;
    @Action("getBusinessDocType") getBusinessDocType: Function;

    @Getter gitBranchInfo: any;
    @Action("getGitRemoteBranchName") getGitRemoteBranchName: Function;

    @Getter saveForm: any;
    @Action saveDocProduct: Function;

    get IsHome() {
      return this.productDoc.HomeSortOrder?1:0;
    }

    iconVisible: any = false;
    docVersionErr: string = "";
    homePageMaxItem: any = 6;

    data() {
      return {
        rules: {
          Name: [
            { required: true, message: '名称不能为空', trigger: 'blur' },
            { min: 1, max: 512, message: '名称长度不能超过512', trigger: 'blur' }
          ],
          IsEnabled: [
            { required: true, message: '是否启用不能为空', trigger: 'blur' }
          ],
          IsHome: [
            { required: true, message: '首页展示不能为空', trigger: 'blur' }
          ],
          HomeSortOrder: [
            { required: true, message: '首页展示顺序不能为空', trigger: 'blur' }
          ],
          SortOrder: [
            { required: true, message: '排序不能为空', trigger: 'blur' }
          ],
          ImageUrl: [
            { required: true, message: '图标不能为空', trigger: 'blur' }
          ],
          ProductDocCatalog: [
            { required: true, message: '业务类-文档目录不能为空', trigger: 'blur' }
          ]
        }
      }
    }

    mounted() {
      this.getBusinessDocType();
    }

    addDocVersion() {
      var selectedRow = null;
      var index = -1;
      if(!this.productDoc.DocVersions){
        this.productDoc.DocVersions = [];
      }else {
        selectedRow = this.productDoc.DocVersions.filter((a:any)=>a.editing)[0];
        index = this.productDoc.DocVersions.findIndex((a:any)=>a.editing);
      }

      index = index < 0 ? 0 : index+1;

      var lastGitUrl = selectedRow ? selectedRow.DesignDocGitURL : "";

      this.productDoc.DocVersions.splice(index, 0, {id: this.productDoc.DocVersions.length + 1,  editing: false,DesignDocGitURL:lastGitUrl,BranchName:"",VersionName:"" });
    }

    deleteDocVersion(row: any){
      let index = this.productDoc.DocVersions.indexOf(row);
      if (index !== -1) {
        this.productDoc.DocVersions.splice(index, 1);
      }
    }

    confirmSelectIcon(icon: any){
      this.$set(this.productDoc, 'ImageUrl', icon);
      this.iconVisible = false;
    }

    selectDocVersion(row: any, column: any){
      this.productDoc.DocVersions.forEach((item: any) => {
        if(row.id){
          this.$set(item, 'editing', item.id == row.id);
        } else if(row.DocVersionGUID){
          this.$set(item, 'editing', item.DocVersionGUID == row.DocVersionGUID);
        }
      });
      this.docVersionErr = "";
    }

    openDocCenter() {
      window.open(this.businessUrl);
    }

    gitAddressChange(row: any){
      this.$set(row, 'BranchName', null);
      this.$set(row, 'branchs', null);
    }

    pullBranchs(row: any){
      if(row.DesignDocGitURL && row.DesignDocGitURL.length > 0){
        this.getGitRemoteBranchName({gitUrl:row.DesignDocGitURL}).then(()=>{
          if(this.gitBranchInfo.IsValid){
            Message.success("分支拉取成功");
            this.$set(row, 'branchs', this.gitBranchInfo.RemoteBranchNames);
          }else {
            Message.error({
              dangerouslyUseHTMLString: true,
              message: this.gitBranchInfo.SummaryErrorMessage
            });
          }
        });
      }else {
        var warningInfo = {
          message: "拉取分支前，请先填写git地址",
          offset: 160
        }
        Message.error(warningInfo);
      }
    }

    // 关闭弹窗
    handleClose() {
        this.$emit('closeProductDocVisible', false);
        this.$refs['form'].resetFields();
    }
        // 确认选择的条目
    confirmbtn() {
      this.$refs['form'].validate((valid: any) => {
        if (valid) {
          if(this.productDoc.DocVersions && this.productDoc.DocVersions.length > 0){
            const versionhNames: string[] = [];
            let hasErr: any = false;
            this.productDoc.DocVersions.forEach((row: any) => {
              var errInfo = {BranchName: '', DesignDocGitURL: '', VersionName: ''};
              if(!row.VersionName || row.VersionName.length == 0){
                errInfo.VersionName = "版本名称不能为空";
              }else if(row.VersionName.length > 128){
                errInfo.VersionName = "版本名称不能超过128个字符";
              }else if(versionhNames.includes(row.VersionName)){
                errInfo.VersionName = "版本名称不能重复";
              }else {
                versionhNames.push(row.VersionName);
              }
  
              if(!row.DesignDocGitURL || row.DesignDocGitURL.length == 0){
                errInfo.DesignDocGitURL = "git地址不能为空";
              }else if(row.DesignDocGitURL.length > 1024){
                errInfo.DesignDocGitURL = "git地址不能超过1024个字符";
              }

              if(!row.BranchName || row.BranchName.length == 0){
                errInfo.BranchName = "分支名称不能为空";
              }

              hasErr = hasErr || !(!errInfo.BranchName && !errInfo.VersionName && !errInfo.DesignDocGitURL);

              this.$set(row, 'Error', errInfo);
            });

            if(hasErr){
              var warningInfo = {
                message: "设计类-文档目录填写有误，请调整",
                offset: 160
              }
              Message.error(warningInfo);
            }else {
              this.submitData();
            }
          }else {
            this.submitData();
          }
        } else {
          return false;
        }
      });
    }

    submitData() {
      this.saveDocProduct(this.productDoc).then(
          () => {
            this.$emit('closeProductDocVisible', true);
          });
    }
}
